<div class="modal-backdrop" (click)="onClose()"></div>

<div class="modal">
  <div class="modal-header">
    <h2>{{ isEdit ? 'Edit Distributor' : 'Add Distributor' }}</h2>
    <span class="icon-btn" (click)="onClose()">
      <i class="fas fa-times"></i>
    </span>
  </div>

  <form (ngSubmit)="onSubmit()" #form="ngForm">
    <div class="modal-body">

      <div class="grid">

        <!-- Distributor Code -->
        <div class="form-group">
          <input type="text" [(ngModel)]="distributor.distributor_code" name="distributor_code" required
            placeholder=" " />
          <label>Distributor Code</label>
          <span class="error" *ngIf="fieldErrors['distributor_code']">{{fieldErrors['distributor_code']}}</span>
        </div>

        <!-- Name -->
        <div class="form-group">
          <input type="text" [(ngModel)]="distributor.distributor_name" name="distributor_name" required
            placeholder=" " />
          <label>Name</label>
          <span class="error" *ngIf="fieldErrors['distributor_name']">{{fieldErrors['distributor_name']}}</span>
        </div>

        <!-- Email -->
        <div class="form-group">
          <input type="email" [(ngModel)]="distributor.email" name="email" required placeholder=" " />
          <label>Email</label>
          <span class="error" *ngIf="fieldErrors['email']">{{fieldErrors['email']}}</span>
        </div>

        <!-- Phone -->
        <div class="form-group">
          <input type="text" [(ngModel)]="distributor.phone_number" name="phone_number" required placeholder=" " />
          <label>Phone</label>
          <span class="error" *ngIf="fieldErrors['phone_number']">{{fieldErrors['phone_number']}}</span>
        </div>

        <!-- Alt Phone -->
        <div class="form-group">
          <input type="text" [(ngModel)]="distributor.alt_phone_number" name="alt_phone_number" placeholder=" " />
          <label>Alt Phone</label>
        </div>

        <!-- GST -->
        <div class="form-group">
          <input type="text" [(ngModel)]="distributor.gst" name="gst" placeholder=" " />
          <label>GST</label>
        </div>

        <!-- PAN -->
        <div class="form-group">
          <input type="text" [(ngModel)]="distributor.pan" name="pan" required placeholder=" " />
          <label>PAN</label>
          <span class="error" *ngIf="fieldErrors['pan']">{{fieldErrors['pan']}}</span>
        </div>

        <!-- Agency -->
        <div class="form-group full">
          <input type="text" [(ngModel)]="distributor.distributor_agency" name="distributor_agency" placeholder=" " />
          <label>Agency</label>
        </div>

        <!-- Address -->
        <div class="form-group full">
          <input type="text" [(ngModel)]="distributor.address_line1" name="address_line1" required placeholder=" " />
          <label>Address Line 1</label>
        </div>

        <div class="form-group full">
          <input type="text" [(ngModel)]="distributor.address_line2" name="address_line2" placeholder=" " />
          <label>Address Line 2</label>
        </div>

        <!-- Location -->
        <div class="form-group">
          <input type="text" [(ngModel)]="distributor.pincode" name="pincode" (ngModelChange)="onPincodeChange($event)" required placeholder=" " />
          <label>Pincode</label>
        </div>

        <div class="form-group">
          <input type="text" [(ngModel)]="distributor.city" name="city" [readOnly]="pinLocationVerified" required placeholder=" " />
          <label>City</label>
        </div>

        <div class="form-group">
          <input type="text" [(ngModel)]="distributor.state" name="state" [readOnly]="pinLocationVerified" required placeholder=" " />
          <label>State</label>
        </div>

      </div>

      <div *ngIf="errorMsg" class="error-msg">{{errorMsg}}</div>

    </div>

    <div class="modal-footer">
      <button class="btn secondary" type="button" (click)="onClose()">Cancel</button>
      <button class="btn primary" type="submit" [disabled]="submitting">
        {{ submitting ? 'Saving...' : 'Save' }}
      </button>
    </div>
  </form>
</div>